
import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');
export const IS_BOT = new InjectionToken<boolean>('IS_BOT');
export const USER_AGENT = new InjectionToken<string>('USER_AGENT');
